import { useAppSelector } from '@src/redux/hooks.ts';
import { SHARE_BINDING_STATUS, SOCIAL_KEY } from '@src/constants/FJShareSocialConstant.ts';
import { useEffect, useState } from 'react';
import FJPublishManager from '@src/manager/publish/FJPublishManager.ts';
import FJMessageStore from '@src/store/FJMessageStore';
import FJLocalStore from '@src/store/FJLocalStore';
import FJLinkedinView from '@src/components/FJModals/FJShareModal/FJShareContent/target/FJLinkedinView.tsx';
import FJRequirementsUtil from '@src/util/FJRequirementsUtil';

const FJLinkedinContainer = () => {
    const isShow = useAppSelector(state => state.share.isShow);
    const userInfo = useAppSelector(state => state.share.linkedin);
    const selectedShareTypes: (typeof SOCIAL_KEY)[keyof typeof SOCIAL_KEY][] = useAppSelector(
        state => state.share.selectedShareTypes,
    );

    const [defaultDescription, setDefaultDescription] = useState('');
    const [isLoadingDescription, setIsLoadingDescription] = useState(false);

    const isSelected = isShow && selectedShareTypes.includes(SOCIAL_KEY.LINKEDIN);

    useEffect(() => {
        if (isSelected) {
            const target = FJPublishManager.getPublishTarget(SOCIAL_KEY.LINKEDIN);
            if (target) {
                setDefaultDescription(target.description);
            }
        }
    }, [isSelected]);

    const onCreateDescription = () => {
        if (isLoadingDescription) {
            return;
        }
        setIsLoadingDescription(true);
        FJRequirementsUtil.eaLog('ai_rewrite_click', { platform: SOCIAL_KEY.LINKEDIN, location: 'description' });
        FJPublishManager.getTextData(SOCIAL_KEY.LINKEDIN, ['caption', 'hashtags'])
            .then(() => {
                const target = FJPublishManager.getPublishTarget(SOCIAL_KEY.LINKEDIN);
                if (target) {
                    setDefaultDescription(target.description);
                }
            })
            .catch(e => {
                if (e.message === '403') {
                    FJMessageStore.addMessage(FJLocalStore._('get-text-limt'), 'error');
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('Failed to generate text. Please try again'), 'error');
                }
            })
            .finally(() => {
                setIsLoadingDescription(false);
            });
    };

    const isActive =
        isShow &&
        userInfo.linkAccountState === SHARE_BINDING_STATUS.LINKED &&
        selectedShareTypes.includes(SOCIAL_KEY.LINKEDIN);

    if (!isActive) {
        return null;
    }

    return (
        <FJLinkedinView
            data={userInfo}
            defaultDescription={defaultDescription}
            onCreateDescription={onCreateDescription}
            isLoadingDescription={isLoadingDescription}
        />
    );
};

export default FJLinkedinContainer;
